// Module
var code = "<h1 id=datatable-数据表格>DataTable 数据表格</h1> <p>通用数据表格。</p> <p>封装了远程/本地分页、远程/本地加载、去抖、时序、数据驱动, 动态列。</p> <h2 id=何时使用>何时使用</h2> <ul> <li>所有的查询表格。</li> </ul> ";
// Exports
module.exports = code;